import { useTrainerReviews } from '@/hooks/useTrainerReviews';
import * as Typography from '@/components/shadcn/typography';

interface Props {
  data: any;
}

export default function ReviewsCount({ data }: Props) {
  const toolId = data?.toolId;

  const { getCurrentReviewsCount } = useTrainerReviews();
  const { currentSessionCount, allTimeCount } = getCurrentReviewsCount(toolId);

  if (!toolId) return null;

  return (
    <Typography.H6>{`${currentSessionCount} / ${allTimeCount}`}</Typography.H6>
  );
}
